// removed by extract-text-webpack-plugin
module.exports = {"TeamsView":"TeamsView--24ln4","TeamsTitle":"TeamsTitle--1OsR2","TeamsGrid":"TeamsGrid--41HPY"};